export enum AttributeAgainstEnum {
    GENERAL = "GENERAL",
    ORDER = "ORDER"
  }

export enum OptionEnum{
  COLOR = 'COLOR',
  SIZE = 'SIZE',
  DESTINATION = 'DESTINATION'
}
  